import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, IconButton } from '@mui/material';
import { FakeText, Typography, Card } from '@totalsoft/rocket-ui';
import EngineRuleListComponent from './EngineRuleListComponent';
import PropTypes from 'prop-types';
import { ViewHeadline } from '@mui/icons-material';
import { Add } from '@mui/icons-material';
import { Save } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const EngineRuleListContainer = ({ rules, onSave, containerDispatcher, isReadOnly, validation, loading }) => {
  const { t } = useTranslation();
  const onAddNewEngineRule = () => {
    containerDispatcher({
      type: 'OnAddNewEngineRule'
    });
  };

  const onSaveEngineRules = () => {
    onSave('OnSaveEngineRules', {});
  };

  return loading ? (
    <FakeText lines={10} />
  ) : (
    <Card
      icon={ViewHeadline}
      iconColor='primary'
      title={t('EngineScoring.EngineRule.Title')}
      actions={
        <>
          <Tooltip title={t('Tooltips.EngineScoringGrid.AddRule')}>
            <span>
              <IconButton color='primary' onClick={onAddNewEngineRule} disabled={isReadOnly}>
                <Add />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t('SaveChanges')}>
            <span>
              <IconButton
                color='primary'
                onClick={onSaveEngineRules}
                disabled={!rules.changed || isReadOnly || !(validation |> isValid) || rules.saving}
              >
                <Save />
              </IconButton>
            </span>
          </Tooltip>
        </>
      }
      subheader={<Typography color='error'>{validation |> getErrors}</Typography>}
    >
      <EngineRuleListComponent
        containerDispatcher={containerDispatcher}
        rules={rules}
        isReadOnly={isReadOnly}
        loading={loading}
        validation={validation}
      />
    </Card>
  );
};

EngineRuleListContainer.propTypes = {
  rules: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default EngineRuleListContainer;
